import axios from '@/api/axios';

export const getSettings = async () => {
  return await axios.get(`/settings`);
};

export const updateSettings = async (id: number, data: any = {}) => {
  return await axios.post(`/settings/update/${id}`, data);
};
